/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AssuranceOffer
 */
export interface AssuranceOffer {
    /**
     * 
     * @type {boolean}
     * @memberof AssuranceOffer
     */
    'eligible'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AssuranceOffer
     */
    'fee'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssuranceOffer
     */
    'base_amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssuranceOffer
     */
    'fee_rate'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssuranceOffer
     */
    'reason'?: AssuranceOfferReasonEnum;
}

export const AssuranceOfferReasonEnum = {
    feature_disabled: 'feature_disabled',
    location_unsupported: 'location_unsupported',
    trip_too_soon: 'trip_too_soon',
    booking_state_invalid: 'booking_state_invalid'
} as const;

export type AssuranceOfferReasonEnum = typeof AssuranceOfferReasonEnum[keyof typeof AssuranceOfferReasonEnum];


